import React from "react";
import { Tag } from "antd";

const BooleanTag = ({ ...props }) => {
  return props.value ? <Tag className="boolean-tag-true">{props.literal ? "True" : "Yes"}</Tag> : <Tag className="boolean-tag-false">{props.literal ? "False" : "No"}</Tag>;
};

export default BooleanTag;
